import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Angular2TokenService } from 'angular2-token';

@Injectable()
export class SignInIffNotAuthorisedGuard implements CanActivate {

  constructor(
    private _tokenService: Angular2TokenService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this._tokenService.userSignedIn()) { return true; }

    location.reload();
    return false;
  }
}

@Injectable()
export class RedirectToMainIfSignedIn implements CanActivate {

  constructor(
    private _tokenService: Angular2TokenService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this._tokenService.userSignedIn()) {
      this.router.navigate(['contacts']);
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/router-guard.ts